var _Logger_config;
import { __classPrivateFieldGet, __classPrivateFieldSet } from "tslib";
import { LogLevel } from './_types';
import testLogVerbosity from "./utils/testLogVerbosity";
import ScopedLogger from "./ScopedLogger";
import errorAndMessageToString from './utils/errorAndMessageToString';
const defaultConfig = {
    loggingVerbosity: LogLevel.Info,
};
export default class Logger {
    constructor(config = defaultConfig) {
        _Logger_config.set(this, void 0);
        __classPrivateFieldSet(this, _Logger_config, config, "f");
    }
    debug(msg, ...args) {
        this.log(LogLevel.Debug, msg, ...args);
    }
    debugError(err, msg, ...args) {
        this.log(LogLevel.Debug, errorAndMessageToString(msg, err), err, ...args);
    }
    error(msg, ...args) {
        this.log(LogLevel.Error, msg, ...args);
    }
    errorError(err, msg, ...args) {
        this.log(LogLevel.Error, errorAndMessageToString(msg, err), err, ...args);
    }
    info(msg, ...args) {
        this.log(LogLevel.Info, msg, ...args);
    }
    infoError(err, msg, ...args) {
        this.log(LogLevel.Info, errorAndMessageToString(msg, err), err, ...args);
    }
    trace(msg, ...args) {
        this.log(LogLevel.Trace, msg, ...args);
    }
    traceError(err, msg, ...args) {
        this.log(LogLevel.Trace, errorAndMessageToString(msg, err), err, ...args);
    }
    warn(msg, ...args) {
        this.log(LogLevel.Warn, msg, ...args);
    }
    warnError(err, msg, ...args) {
        this.log(LogLevel.Warn, errorAndMessageToString(msg, err), err, ...args);
    }
    scope(name) {
        return new ScopedLogger(this, name);
    }
    /**
     * Calls the implementation of the logging level
     * @param level
     * @param msg
     * @param args extra objects/values to include with the log message
     */
    log(level, msg, ...args) {
        if (testLogVerbosity(level, __classPrivateFieldGet(this, _Logger_config, "f").loggingVerbosity)) {
            const message = `${Logger.openLevel}${level}${Logger.closeLevel} ${msg}`;
            switch (level) {
                case LogLevel.Error:
                    this._errorMethod(message, ...args);
                    break;
                case LogLevel.Warn:
                    this._warnMethod(message, ...args);
                    break;
                case LogLevel.Info:
                    this._infoMethod(message, ...args);
                    break;
                case LogLevel.Trace:
                    this._traceMethod(message, ...args);
                    break;
                case LogLevel.Debug:
                    this._debugMethod(message, ...args);
                    break;
                default:
                    this._defaultMethod(message, ...args);
                    break;
            }
        }
    }
}
_Logger_config = new WeakMap();
Logger.openLevel = '[';
Logger.closeLevel = ']';
